import React from "react";

function SyslogServerIpField({ value, onChange }) {

    const handleChange = async (value) => {
        onChange(value);
    }

    return (
        <div className="oct_settings-field">
            <label className="oct_settings-label">IP ADDRESS</label>
            <input className="oct_settings-input-v2"
                id="ip"
                value={value}
                placeholder="Enter IP address"
                onChange={event => handleChange(event.target.value)} />
        </div>
    )
}

export default SyslogServerIpField;
